var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-province"},[_c('d-cascader',{attrs:{"placeholder":"省/市/区","options":_vm.data,"size":_vm.size},on:{"change":_vm.handleChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }